import style from './Menu.module.scss';
import CameraIndoorIcon from '@mui/icons-material/CameraIndoor';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import { useDispatch, useSelector } from 'react-redux'
import { NavLink, useLocation } from 'react-router-dom'
import LightModeIcon from '@mui/icons-material/LightMode';
import NightsStayIcon from '@mui/icons-material/NightsStay';
import { setTopic } from '../../../redux/headerSlices/HeaderSlices';
import { fetchTrends } from '../../../redux/contentSlices/asyncActions'
import { fetchMovies } from '../../../redux/contentSlices/asyncActions'
import { selectFilter } from '../../../redux/filterSlices/FilterSelector'
import { selectHeader } from '../../../redux/headerSlices/HeaderSelector'
import { useAppDispatch } from '../../../redux/Store';
import { grey } from '@mui/material/colors';


let Menu = () => {

    const location = useLocation();

    const dispatch = useAppDispatch();

    const { type, sortingBy, minRating, ordering } = useSelector(selectFilter)

    let { topic, search } = useSelector(selectHeader)

    async function getMovieHome() {
        dispatch(fetchMovies({ type, minRating, sortingBy, ordering, search }))
        window.scrollTo(0, 0);
    }

    async function getMovieTrends() {
        dispatch(fetchTrends())
        window.scrollTo(0, 0);
    }

    console.log(location.pathname)
    return (
        <div className={style.Box__menu} title="select the desired section">
            <div className={style.menu}>
                <div className={style.menu__block} onClick={() => getMovieHome()}>{
                    location.pathname === '/' ?
                        <NavLink to='/' > <CameraIndoorIcon sx={{ fontSize: 40 }} /></NavLink>
                        :
                        <NavLink to='/'> <CameraIndoorIcon sx={{ fontSize: 40, color: grey[700] }} /></NavLink>
                }
                </div>
                <div className={style.menu__block} onClick={() => getMovieTrends()}>
                    {location.pathname === '/trends' ?
                        <NavLink to='/trends'  ><LocalFireDepartmentIcon sx={{ fontSize: 40 }} /></NavLink>
                        :
                        <NavLink to='/trends' ><LocalFireDepartmentIcon sx={{ fontSize: 40, color: grey[700] }} /></NavLink>
                    }
                </div>
                <div className={style.menu__block}>
                    {location.pathname === '/bookmarks' ? <NavLink to='/bookmarks'  ><BookmarksIcon sx={{ fontSize: 40 }} /></NavLink>
                        : <NavLink to='/bookmarks'  ><BookmarksIcon sx={{ fontSize: 40, color: grey[700] }} /></NavLink>}
                </div>
                <div className={style.menu__block} >
                    {topic ? <LightModeIcon sx={{ fontSize: 40 }} onClick={e => dispatch(setTopic(false))} />
                        : <NightsStayIcon sx={{ fontSize: 40, color: grey[700] }} onClick={e => dispatch(setTopic(true))} />}
                </div>
            </div>
        </div>
    )
}

export default Menu;